module.exports = __webpack_public_path__ + "static/dei_itv_mariama-41e18c9fabc0e159e8bcda6a7d54fa55.png";